import axios, { AxiosRequestConfig, AxiosTransformer } from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'

// Axios defaults
axios.defaults.withCredentials = true

// Default API module for JSON requests
const defaultAxiosModule = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
})
defaultAxiosModule.defaults.transformRequest = [
  (data) => {
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      return data
    }
    return data && decamelizeKeys(data)
  },
  ...(axios.defaults.transformRequest as AxiosTransformer[]),
]
defaultAxiosModule.defaults.transformResponse = [
  ...(axios.defaults.transformResponse as AxiosTransformer[]),
  (data) => data && camelizeKeys(data),
]

defaultAxiosModule.interceptors.request.use(
  (config: AxiosRequestConfig) =>
    Object.assign({}, config, { url: `${config.url}.json` }),
  (error) => Promise.reject(error),
)

// Regular axios module for any other requests
export const AxiosModule = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
})

export default defaultAxiosModule
